module.exports = __webpack_public_path__ + "static/media/Carta menú dorado.0be383e1.svg";